import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Button from 'components/common/Button';
import Form from 'components/form';
import PhoneInput from 'components/form/PhoneInput';
import Input from 'components/form/Input';
import { validatePhone, validateEmail } from 'utils';
import { Card } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import StopIcon from '@material-ui/icons/Stop';
import Typography from '@material-ui/core/Typography';
import TermsModal from './TermsModal';
import {
  onSendInvitebyEmail,
  onSendInvitebyPhone,
  hashCode,
} from 'utils/referralInvite';
import { useMutation } from 'react-apollo';
import useSnack from 'hooks/useSnack';
import { INSERT_CONTACTS } from 'graphql/referral/contacts';
import { useSelector } from 'react-redux';

const FormItem = Form.FormItem;

const styles = (theme) => ({
  alert: {
    'backgroundColor': '#000',
    'paddingRight': 24,
    'color': '#fff',
    [theme.breakpoints.down('sm')]: {
      'display': 'block',
      'padding': theme.spacing(3),
      '& .MuiAlert-message': {
        marginBottom: theme.spacing(3),
      },
      '& .MuiAlert-action': {
        paddingLeft: 0,
      },
    },
    '& .MuiAlert-icon': {
      marginLeft: -6,
    },
  },
  ReferralPopup: {
    background: 'none',
    'color': 'black',
    [theme.breakpoints.down('sm')]: {
      'display': 'block',
      'padding': theme.spacing(3),
      '& .MuiAlert-message': {
        marginBottom: theme.spacing(3),
      },
      '& .MuiAlert-action': {
        paddingLeft: 0,
      },
    },
    '& .MuiAlert-icon': {
      display: 'none',
    },

  },
  popUpForm: {

  }
});

const ReferralCard = ({
  referral,
  form: { getFieldDecorator, validateFields, resetFields },
  onSubmit,
  classes,
  style
}) => {
  const snack = useSnack();
  const user = useSelector((s) => s.user.user);
  const [insertContacts] = useMutation(INSERT_CONTACTS);
  const [showTerms, setShowTerms] = useState(false);

  const handleSubmit = async () => {
    try {
      await validateFields().then(sendInvite);
      await resetFields();
      onSubmit && onSubmit();
    } catch (e) {
      console.log(e);
    }
  };

  const sendInvite = async (val) => {
    const {
      data: { rows },
    } = await insertContacts({
      variables: {
        data: [
          {
            phone: val.user_phone,
            email: val.user_email,
            source: 'manual',
            external_id: hashCode(val.user_phone),
            user_id: user.id,
            first_name: val.first_name,
            last_name: val.last_name,
          },
        ],
      },
    });
    const contacts = rows.returning;

    await Promise.all([
      onSendInvitebyPhone({
        referral,
        contacts,
        user,
        snack,
      }),
      onSendInvitebyEmail({
        referral,
        contacts,
        user,
        snack,
      }),
    ]).catch((e) => {
      console.log(e);
    });
    snack.success('Invite sent successfully');
    window.analytics.track('Referral.Invite.Clicked', {
      fullName: val.first_name + ' ' + val.last_name,
      Mobile: val.user_phone,
      Email: val.user_email,
    });
  };

  return (
    <Box>
      <Box>
        <Alert className={style === 'referral_popup' ? classes.ReferralPopup : classes.alert} icon={<StopIcon color="primary" />}>
          <Typography gutterBottom variant="subtitle1">
            Refer a Friend
          </Typography>
          <Typography color="inherit" variant="body2">
            For each valid invitation, you will receive $5.
          </Typography>
        </Alert>
      </Box>
      <Card>
        <Box p={2}>
          <FormItem>
            {getFieldDecorator('first_name', {
              initialValue: '',
              rules: [
                {
                  required: true,
                  message: 'This is a required field *',
                },
              ],
            })(
              <Input
                fullWidth
                classes={{ root: classes.input }}
                margin="normal"
                variant="outlined"
                placeholder="First Name *"
              />,
            )}
          </FormItem>
          <FormItem>
            {getFieldDecorator('last_name', {
              initialValue: '',
              rules: [
                {
                  required: true,
                  message: 'This is a required field *',
                },
              ],
            })(
              <Input
                fullWidth
                classes={{ root: classes.input }}
                margin="normal"
                variant="outlined"
                placeholder="Last Name *"
              />,
            )}
          </FormItem>
          <FormItem>
            {getFieldDecorator('user_email', {
              initialValue: '',
              rules: [
                {
                  required: true,
                  message: 'This is a required field *',
                },
                { validator: validateEmail },
              ],
            })(<Input placeholder="Email Address *" />)}
          </FormItem>
          <FormItem>
            {getFieldDecorator('user_phone', {
              rules: [
                { required: true, message: 'This is a required field *' },
                { validator: validatePhone },
              ],
            })(<PhoneInput placeholder="Phone Number *" />)}
          </FormItem>
          <Box mb={2}>
            <Button
              color="primary"
              onClick={() => setShowTerms(true)}
              variant="text"
            >
              Click here to read the terms and conditions.
            </Button>
          </Box>
          <Box>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={handleSubmit}
            >
              {'Invite'}
            </Button>
          </Box>
        </Box>
      </Card>
      {showTerms && <TermsModal onClose={() => setShowTerms(false)} />}
    </Box>
  );
};

export default Form.create()(withStyles(styles)(ReferralCard));
